import { useNetwork } from '../contexts/NetworkContext';
import { WifiOff } from 'lucide-react';
import { useTranslation } from 'react-i18next';
import { Button } from './ui/button';

export function NetworkBanner() {
  const { t } = useTranslation('common');
  const { isOnline, isSessionExpired, dismissSessionExpired } = useNetwork();

  if (isSessionExpired) {
    return (
      <div
        className="border-b border-amber-400 bg-amber-50 px-6 py-3"
        data-testid="session-expired-banner"
      >
        <div className="mx-auto flex max-w-4xl items-center justify-between">
          <p className="text-sm font-medium text-amber-800">
            {t('network_banner.session_expired')}
          </p>
          <Button
            size="sm"
            variant="outline"
            data-testid="session-expired-login"
            onClick={dismissSessionExpired}
          >
            {t('network_banner.session_expired_login')}
          </Button>
        </div>
      </div>
    );
  }

  if (!isOnline) {
    return (
      <div
        className="border-b border-red-400 bg-red-50 px-6 py-2"
        data-testid="connection-lost-banner"
      >
        <div className="mx-auto flex max-w-4xl items-center gap-2">
          <WifiOff className="h-4 w-4 text-red-600" />
          <p className="text-sm font-medium text-red-700">
            {t('network_banner.connection_lost')}
          </p>
        </div>
      </div>
    );
  }

  return null;
}
